export const loaderRoute = {
  base: '/loader',
  jobs: '/jobs',
  crm: '/crm',
  leads: '/leads',
  clients: '/clients',
  communication: '/communication',
  quotes: '/quotes',
  inventory: '/inventory',
  product: '/product',
  package: '/package',
  settings: '/settings',
  users: '/users',
  schedule: '/schedule',
  vehicles: '/vehicles',
  trucks: '/trucks',
  equipments: '/equipments',
  trailers: '/trailers',
  vendors: '/vendors',
  purchaseOrder: '/purchase-order',
  order: '/order',
  roleManagement: '/role-management',
  coupon: '/coupon',
  eventType: '/event-type',
  category: '/category',
  quarantines: '/quarantine',
  invoice: '/invoice',
  checklist: '/checklist',
  task: '/task',
  global: '/global',
  venue: '/venue',

  // Reports
  reports: '/reports',
  overbookingItem: '/overbooking-item',
  subrentalsReport: '/subrentals',
  quarantineReport: '/quarantine',
  foremanTaskReport: '/foreman-task-completion',
  clientIncomeReport: '/client-income',
  revenueReport: '/revenue',
  geographicRevenueReport: '/geographic-revenue',
  quoteRevenueReport: '/quote-revenue',
  orderRevenueReport: '/order-revenue',
  cancellationReport: '/cancellation',
  deliveryReport: '/delivery-pickup',
  taskCompletionReport: '/task-completion',
  discountUsageReport: '/discount-usage',
  featureUtilizationReport: '/feature-utilization',
  jobCostingReport: '/job-costing',
  inventoryUsageReport: '/inventory-usage',
  marketingRevenueReport: '/marketing-revenue',
  financialOrderReport: '/financial-order',
  transactionSummaryReport: '/transaction-summary',

  // Common
  commonCreate: '/create',
  commonEdit: '/edit',
  commonClone: '/clone',
  commonDetail: '/:id',
};

export const loaderRouteVehicles = {
  vehicles: `${loaderRoute.base}${loaderRoute.vehicles}`,
};

export const loaderRouteTrucks = {
  trucks: `${loaderRoute.base}${loaderRoute.vehicles}${loaderRoute.trucks}`,
};

export const loaderRouteEquipments = {
  equipments: `${loaderRoute.base}${loaderRoute.vehicles}${loaderRoute.equipments}`,
};

export const loaderRouteTrailers = {
  trailers: `${loaderRoute.base}${loaderRoute.vehicles}${loaderRoute.trailers}`,
};

export const loaderRouteVendors = {
  vendors: `${loaderRoute.base}${loaderRoute.vendors}`,
  detailVendor: `${loaderRoute.base}${loaderRoute.vendors}${loaderRoute.commonDetail}`,
};

export const loaderRoutePurchaseOrder = {
  purchaseOrder: `${loaderRoute.base}${loaderRoute.purchaseOrder}`,
  detailPurchaseOrder: (purchaseOrderId: string) =>
    `${loaderRoute.base}${loaderRoute.purchaseOrder}/${purchaseOrderId}`,
};

export const loaderRouteOrder = {
  order: `${loaderRoute.base}${loaderRoute.order}`,
  detailOrder: (orderId: string) => `${loaderRoute.base}${loaderRoute.order}/${orderId}`,
  updateOrder: (orderId: string) => `${loaderRoute.base}${loaderRoute.order}/${orderId}${loaderRoute.commonEdit}`,
};

export const loaderRouteCrm = {
  crm: `${loaderRoute.base}${loaderRoute.crm}`,
  leads: `${loaderRoute.base}${loaderRoute.crm}${loaderRoute.leads}`,
  createLead: `${loaderRoute.base}${loaderRoute.crm}${loaderRoute.leads}${loaderRoute.commonCreate}`,
  detailLead: (leadId: string) => `${loaderRoute.base}${loaderRoute.crm}${loaderRoute.leads}/${leadId}`,
  updateLead: (leadId: string) =>
    `${loaderRoute.base}${loaderRoute.crm}${loaderRoute.leads}/${leadId}${loaderRoute.commonEdit}`,
  clients: `${loaderRoute.base}${loaderRoute.crm}${loaderRoute.clients}`,
  createClient: `${loaderRoute.base}${loaderRoute.crm}${loaderRoute.clients}${loaderRoute.commonCreate}`,
  detailClient: (clientId: string) => `${loaderRoute.base}${loaderRoute.crm}${loaderRoute.clients}/${clientId}`,
  updateClient: (clientId: string) =>
    `${loaderRoute.base}${loaderRoute.crm}${loaderRoute.clients}/${clientId}${loaderRoute.commonEdit}`,
};

export const loaderRouteQuote = {
  quotes: `${loaderRoute.base}${loaderRoute.quotes}`,
  createQuotes: `${loaderRoute.base}${loaderRoute.quotes}${loaderRoute.commonCreate}`,
  detailQuote: (quoteId: string) => `${loaderRoute.base}${loaderRoute.quotes}/${quoteId}`,
  updateQuote: (quoteId: string) => `${loaderRoute.base}${loaderRoute.quotes}/${quoteId}${loaderRoute.commonEdit}`,
};

export const loaderRouteInventory = {
  inventories: `${loaderRoute.base}${loaderRoute.inventory}`,
  inventory: `${loaderRoute.base}${loaderRoute.inventory}${loaderRoute.product}`,
  createInventory: `${loaderRoute.base}${loaderRoute.inventory}${loaderRoute.product}${loaderRoute.commonCreate}`,
  detailInventory: (inventoryId: string) =>
    `${loaderRoute.base}${loaderRoute.inventory}${loaderRoute.product}/${inventoryId}`,
  updateInventory: (inventoryId: string) =>
    `${loaderRoute.base}${loaderRoute.inventory}${loaderRoute.product}/${inventoryId}${loaderRoute.commonEdit}`,
};

export const loaderRoutePackage = {
  package: `${loaderRoute.base}${loaderRoute.inventory}${loaderRoute.package}`,
  createPackage: `${loaderRoute.base}${loaderRoute.inventory}${loaderRoute.package}${loaderRoute.commonCreate}`,
  updatePackage: (packageId: string) =>
    `${loaderRoute.base}${loaderRoute.inventory}${loaderRoute.package}/${packageId}${loaderRoute.commonEdit}`,
  clonePackage: (packageId: string) =>
    `${loaderRoute.base}${loaderRoute.inventory}${loaderRoute.package}/${packageId}${loaderRoute.commonClone}`,
};

export const loaderRouteUser = {
  users: `${loaderRoute.base}${loaderRoute.settings}${loaderRoute.users}`,
  createUser: `${loaderRoute.base}${loaderRoute.settings}${loaderRoute.users}${loaderRoute.commonCreate}`,
  detailUser: (userId: string) => `${loaderRoute.base}${loaderRoute.settings}${loaderRoute.users}/${userId}`,
  updateUser: (userId: string) =>
    `${loaderRoute.base}${loaderRoute.settings}${loaderRoute.users}/${userId}${loaderRoute.commonEdit}`,
};

export const loaderRouteVenue = {
  venue: `${loaderRoute.base}${loaderRoute.settings}${loaderRoute.venue}`,
  createVenue: `${loaderRoute.base}${loaderRoute.settings}${loaderRoute.venue}${loaderRoute.commonCreate}`,
  detailVenue: (venueId: string) => `${loaderRoute.base}${loaderRoute.settings}${loaderRoute.venue}/${venueId}`,
  updateVenue: (venueId: string) =>
    `${loaderRoute.base}${loaderRoute.settings}${loaderRoute.venue}/${venueId}${loaderRoute.commonEdit}`,
};

export const loaderRouteInvoice = {
  invoices: `${loaderRoute.base}${loaderRoute.invoice}`,
  createInvoice: `${loaderRoute.base}${loaderRoute.invoice}${loaderRoute.commonCreate}`,
  updateInvoice: (invoiceId: string) =>
    `${loaderRoute.base}${loaderRoute.invoice}/${invoiceId}${loaderRoute.commonEdit}`,
};

export const loaderRouteRoleManagement = {
  roleManagement: `${loaderRoute.base}${loaderRoute.settings}${loaderRoute.roleManagement}`,
  createRole: `${loaderRoute.base}${loaderRoute.settings}${loaderRoute.roleManagement}${loaderRoute.commonCreate}`,
  updateRole: (roleId: string) =>
    `${loaderRoute.base}${loaderRoute.settings}${loaderRoute.roleManagement}/${roleId}${loaderRoute.commonEdit}`,
};

export const loaderRouteRoleCoupon = {
  coupon: `${loaderRoute.base}${loaderRoute.settings}${loaderRoute.coupon}`,
};

export const loaderRouteRoleEventType = {
  eventType: `${loaderRoute.base}${loaderRoute.settings}${loaderRoute.eventType}`,
};

export const loaderRouteRoleCategory = {
  category: `${loaderRoute.base}${loaderRoute.settings}${loaderRoute.category}`,
};

export const loaderRouteRoleChecklist = {
  checklist: `${loaderRoute.base}${loaderRoute.settings}${loaderRoute.checklist}`,
};

export const loaderRouteJob = {
  jobs: `${loaderRoute.base}${loaderRoute.jobs}`,
  detailJob: (jobId: string) => `${loaderRoute.base}${loaderRoute.jobs}/${jobId}`,
};

export const loaderRouteQuarantine = {
  quarantine: `${loaderRoute.base}${loaderRoute.inventory}${loaderRoute.quarantines}`,
};

export const loaderRouteTask = {
  task: `${loaderRoute.base}${loaderRoute.task}`,
};

export const loaderRouteGlobal = {
  global: `${loaderRoute.base}${loaderRoute.global}`,
};

export const loaderRouteReport = {
  reports: `${loaderRoute.base}${loaderRoute.reports}`,
  overbookingItem: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.overbookingItem}`,
  subrentalsReport: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.subrentalsReport}`,
  clientIncomeReport: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.clientIncomeReport}`,
  revenueReport: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.revenueReport}`,
  geographicRevenueReport: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.geographicRevenueReport}`,
  quoteRevenueReport: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.quoteRevenueReport}`,
  orderRevenueReport: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.orderRevenueReport}`,
  cancellationReport: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.cancellationReport}`,
  deliveryReport: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.deliveryReport}`,
  taskCompletionReport: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.taskCompletionReport}`,
  discountUsageReport: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.discountUsageReport}`,
  featureUtilizationReport: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.featureUtilizationReport}`,
  jobCostingReport: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.jobCostingReport}`,
  inventoryUsageReport: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.inventoryUsageReport}`,
  quarantineReport: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.quarantineReport}`,
  foremanTaskReport: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.foremanTaskReport}`,
  marketingRevenueReport: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.marketingRevenueReport}`,
  financialOrderReport: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.financialOrderReport}`,
  transactionSummaryReport: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.transactionSummaryReport}`,
};

export const loaderRouteAbsolute = {
  // Dashboard
  dashboard: loaderRoute.base,

  // Communication
  communication: `${loaderRoute.base}${loaderRoute.communication}`,

  // Settings
  settings: `${loaderRoute.base}${loaderRoute.settings}`,

  // Schedule
  schedule: `${loaderRoute.base}${loaderRoute.schedule}`,

  ...loaderRouteVehicles,
  ...loaderRouteTrucks,
  ...loaderRouteEquipments,
  ...loaderRouteTrailers,
  ...loaderRouteVendors,
  ...loaderRoutePurchaseOrder,
  ...loaderRouteOrder,
  ...loaderRouteCrm,
  ...loaderRouteQuote,
  ...loaderRouteInventory,
  ...loaderRoutePackage,
  ...loaderRouteUser,
  ...loaderRouteVenue,
  ...loaderRouteRoleManagement,
  ...loaderRouteRoleCoupon,
  ...loaderRouteRoleEventType,
  ...loaderRouteRoleCategory,
  ...loaderRouteRoleChecklist,
  ...loaderRouteJob,
  ...loaderRouteQuarantine,
  ...loaderRouteInvoice,
  ...loaderRouteReport,
  ...loaderRouteTask,
  ...loaderRouteGlobal,
};
